// Fase 5 (SaaS control plane): onboarding self-service + planos/assinatura por tenant.
import { z } from 'zod';
import { MoneyStringSchema } from './common.js';

export const PlanCodeSchema = z.enum(['free', 'pro', 'enterprise']);
export type PlanCode = z.infer<typeof PlanCodeSchema>;

export const SubscriptionStatusSchema = z.enum(['trial', 'ativo', 'inadimplente', 'cancelado']);
export type SubscriptionStatus = z.infer<typeof SubscriptionStatusSchema>;

/** Onboarding self-service (público). Cria tenant + gestor + assinatura trial. */
export const SignupSchema = z.object({
  tenantNome: z.string().min(2),
  tenantSlug: z
    .string()
    .min(3)
    .max(40)
    .regex(/^[a-z0-9-]+$/, 'slug: apenas minúsculas, números e hífen'),
  adminNome: z.string().min(2),
  adminEmail: z.string().email(),
  adminSenha: z.string().min(8, 'senha deve ter ≥ 8 caracteres'),
  planCode: PlanCodeSchema.optional(),
});
export type SignupDTO = z.infer<typeof SignupSchema>;

export const SubscriptionViewSchema = z.object({
  planCode: PlanCodeSchema,
  planNome: z.string(),
  status: SubscriptionStatusSchema,
  precoMensal: MoneyStringSchema,
  maxUsuarios: z.number().int().nullable(),
  maxOrcamentosMes: z.number().int().nullable(),
  currentPeriodEnd: z.string(),
  trialEndsAt: z.string().nullable(),
});
export type SubscriptionViewDTO = z.infer<typeof SubscriptionViewSchema>;

export const SignupResultSchema = z.object({
  tenantId: z.string().uuid(),
  tenantSlug: z.string(),
  subscription: SubscriptionViewSchema,
});
export type SignupResultDTO = z.infer<typeof SignupResultSchema>;
